<script lang="ts" setup>
// One row of the transaction detail. The head is the label and at most one short figure, a duration or a count;
// the body renders only while open, so a closed row costs nothing.
defineProps<{ label: string; open: boolean; figure?: string }>();
defineEmits<{ toggle: [] }>();
</script>

<template>
  <div class="border-top" :data-block="label">
    <div
      class="d-flex align-items-center gap-2 py-2 px-1 transaction-block-head"
      role="button"
      tabindex="0"
      data-toggle
      :aria-expanded="open"
      @click="$emit('toggle')"
      @keydown.enter.prevent="$emit('toggle')"
      @keydown.space.prevent="$emit('toggle')"
    >
      <i class="bi text-body-secondary transaction-block-chevron" :class="open ? 'bi-chevron-down' : 'bi-chevron-right'"></i>
      <span class="fw-medium">{{ label }}</span>
      <small v-if="figure" class="ms-auto text-body-secondary transaction-block-figure">{{ figure }}</small>
    </div>
    <div v-if="open" class="transaction-block-body"><slot /></div>
  </div>
</template>

<style scoped lang="scss">
.transaction-block-head { cursor: pointer; }
.transaction-block-head:hover { background-color: var(--bs-tertiary-bg); }
.transaction-block-chevron { width: 1rem; flex-shrink: 0; }
.transaction-block-figure { font-variant-numeric: tabular-nums; }
/* The head's padding (0.25rem), the chevron (1rem) and the gap (0.5rem) put the label 1.75rem in, so the body
   starts under the label. */
.transaction-block-body { padding: 0.25rem 0.25rem 0.75rem 1.75rem; }
</style>
